'use strict'

export default (mockAxios) => {
  // 添付ファイルサイズ設定取得
  mockAxios.onGet(`/attachsizesettings`).reply(200, {
    'success': true,
    'data': {
      'attachsize': null,
      'attachsizeoptions': {
        '1 MB': 1,
        '3 MB': 3,
        '5 MB': 5
      }
    }
  })

  // 添付ファイル設定更新
  mockAxios.onPut(`/attachsizesettings`).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/attachsizeSettingRepositoryMock.js